export default "<div class=\"navigation\">\n    \n</div>"